import React, { useState } from "react";
import "../css/Faqs.css";

const Faqs = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      q: "What are the gym timings?",
      a: "We operate from 5:00 AM – 11:00 PM (Mon–Sat) and 6:00 AM – 10:00 PM (Sunday)."
    },
    {
      q: "Do you offer trial sessions?",
      a: "Yes! We provide a 1-day complimentary trial for all new members."
    },
    {
      q: "Can I freeze my membership?",
      a: "Absolutely. Membership can be frozen up to 60 days per year for a small fee."
    },
    {
      q: "Do you offer personal training?",
      a: "Yes, our certified personal trainers offer 1-on-1 and small group sessions."
    },
    {
      q: "Are there refunds on memberships?",
      a: "We do not offer refunds, but you can transfer your membership to another person."
    },
    {
      q: "Do you provide diet consultation?",
      a: "Yes. Our experts create personalized diet plans based on your goals."
    },
    {
      q: "Is the gym beginner-friendly?",
      a: "Completely. We have beginner workout programs, trainers, and intro sessions."
    }
  ];

  const toggleFAQ = (i) => {
    setOpenIndex(openIndex === i ? null : i);
  };

  return (
    <div className="faqs-page">

      {/* HERO */}
      <section className="faqs-hero">
        <h1>FAQs</h1>
        <p>Everything you need to know before joining ACE Fitness.</p>
        <span className="red-line"></span>
      </section>


      {/* FAQ LIST */}
      <section className="faq-section">
        <div className="faq-list">
          {faqs.map((item, i) => (
            <div
              key={i}
              className={`faq-item ${openIndex === i ? "open" : ""}`}
              onClick={() => toggleFAQ(i)}
            >
              <div className="faq-question">
                <h3>{item.q}</h3>
                <span className="icon">{openIndex === i ? "−" : "+"}</span>
              </div>

              <div
                className="faq-answer"
                style={{
                  maxHeight: openIndex === i ? "400px" : "0px"
                }}
              >
                <p>{item.a}</p>
              </div>
            </div>
          ))}
        </div>
      </section>


      {/* CTA */}
      <section className="faq-cta">
        <h1>STILL HAVE QUESTIONS?</h1>
        <button>Contact ACE</button>
      </section>

    </div>
  );
};

export default Faqs;
